import axios from 'axios';
import { decamelizeKeys } from 'humps';
import _ from 'lodash';

const oc2ApiBaseUrl: string = process.env.OC2_API_BASE_URL!;

const client = axios.create({
  baseURL: oc2ApiBaseUrl,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF': 'onecareer',
  },
});

client.interceptors.request.use(
  ({ data, ...config }) => ({
    ...config,
    // NOTE: FormDataは変換しない
    data: _.isPlainObject(data) ? decamelizeKeys(data) : data,
  }),
  (error) => Promise.reject(error)
);

export default client;
